import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap-5';
import Button from 'shared/button';

export default class DeleteSavedSearch extends React.Component {
  static propTypes = {
    search: PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    }),
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  };

  render() {
    const {
      search,
      onCancel,
      onDelete
    } = this.props;

    if (search) {
      return (
        <Modal centered show={search != null} onHide={onCancel}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Saved Search</Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex flex-column gap-3">
            <div>
                You are about to delete your saved search <strong>{search.name}</strong>
            </div>
            <div>This action is permanent. Are you sure you want to delete?</div>
          </Modal.Body>
          <Modal.Footer>
            <Button.Primary plain onClick={onCancel}>Cancel</Button.Primary>
            <Button.Danger onClick={onDelete}>Delete</Button.Danger>
          </Modal.Footer>
        </Modal>
      );
    } else {
      return null;
    }
  }
}
